// 葡萄牙语

export default {
  t1: 'Concluir',
  t5: 'Pagar',
  t6: 'Vincular e autorizar',
}
